/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconNavigationX = createSolidComponent("navigation-x", "IconNavigationX", [
  [
    "path",
    {
      d: "M16.622 13.02l-4.622 -10.02l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l1.563 .53"
    }
  ],
  ["path", { d: "M22 22l-5 -5" }],
  ["path", { d: "M17 22l5 -5" }]
]);

export { IconNavigationX as default };
//# sourceMappingURL=IconNavigationX.js.map
